import React, { useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import Col from "antd/lib/col";
import Row from "antd/lib/row";
import Spin from "antd/lib/spin";
import { intlContext } from "translations/context";
import State from "../../models/State";
import * as actions from "../models/actions";
import ProjectListItem from "./ProjectListItem";
import { securedLoanProcessId } from "constants/investProcessId";
import FormattedMessage from "components/FormattedMessage";

export default function ProjectList(props: object): JSX.Element {
  const { loading, projects } = useSelector((state: State) => ({
    loading: state.projectList ? state.projectList.loading : false,
    projects: state.projectList ? state.projectList.projects : []
  }));
  const dispatch = useDispatch();
  const { translate } = useContext(intlContext);

  useEffect(() => {
    dispatch(actions.fetchProjects());
  }, [dispatch]);

  if (loading) {
    return (
      <>
        {translate("project_list_startpage_loading")} <Spin />
      </>
    );
  }

  const securedLoanProjects = projects.filter(({ investProcessId }) => investProcessId === securedLoanProcessId);
  const otherProjects = projects.filter(({ investProcessId }) => investProcessId !== securedLoanProcessId);

  return (
    <Row style={{ display: "flex", flexWrap: "wrap", alignItems: "stretch" }}>
      {securedLoanProjects.length !== 0 && (
        <>
          {securedLoanProjects.map((project, index) => (
            <Col key={index} style={{ padding: "12px 24px 12px 24px" }} lg={8} md={12} sm={24} xs={24}>
              <h5
                style={{
                  backgroundColor: "#7FA88B",
                  color: "#fff",
                  textAlign: "center",
                  lineHeight: "2em",
                  width: "65%",
                  borderRadius: 100,
                  marginBottom: -35,
                  position: "relative",
                  zIndex: 100
                }}
              >
                <FormattedMessage id="project_list_startpage_securedLoan" />
              </h5>
              <ProjectListItem {...project} />
            </Col>
          ))}
        </>
      )}
      {otherProjects.length !== 0 && (
        <>
          {otherProjects.map((project, index) => (
            <Col key={index} style={{ padding: "12px 24px 12px 24px" }} lg={8} md={12} sm={24} xs={24}>
              <h5
                style={{
                  backgroundColor: "#7FA88B",
                  color: "#fff",
                  textAlign: "center",
                  lineHeight: "2em",
                  width: "65%",
                  borderRadius: 100,
                  marginBottom: -35,
                  position: "relative",
                  zIndex: 100
                }}
              >
                <FormattedMessage id="project_list_startpage_subordinatedLoan" />
              </h5>
              <ProjectListItem {...project} />
            </Col>
          ))}
        </>
      )}
    </Row>
  );
}
